export enum CDTooltipType {
  Light,
  Dark,
}
